import { useLoaderData } from "@remix-run/react";
import Container from "~/components/layout/Container";
import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card";
import { Icon } from "~/components/ui/icon";
import { slugify } from "~/lib/slugify";
import { toLocaleDateString } from "~/utils/date";
import { siteTitle } from "../_index";
import { blogPosts } from "../features/BlogNews";
import References from "../features/References";
import Slogans from "../features/Slogans";

export const HizmetSubTitle = "UTB Support olarak sektördeki yenilikleri, güncel gelişmeleri ve firmamızla ilgili önemli haberleri sizlerle buluşturuyoruz. Uluslararası ticaretin dinamik yapısına dair bilgi edinmek, ihracat ve ithalat süreçlerinde daha etkin olmanızı sağlayacak ipuçları ve stratejileri keşfetmek için blog yazılarımıza göz atabilirsiniz. Ayrıca şirketimizden güncel duyuruları ve etkinlikleri de “Haberler” etiketlerinden takip edebilirsiniz. Bilgi dolu içeriklerimizle yanınızdayız!";
export const loader = () => {
  const title = HizmetSubTitle.replaceAll('ş', '<i>&#351;</i>').replaceAll('Ş', '<i>&#350;</i>').replaceAll('ğ', '<i>&#287;</i>').replaceAll('Ğ', '<i>&#286;</i>');
  return { blogPosts, title };
};
export const meta = () => {
  return [{
    title: `BLOG + BİZDEN HABERLER | ${siteTitle}`,
  }]
}
export default function Page() {
  const { blogPosts, title } = useLoaderData<typeof loader>();
  return (
    <div className="pt-[122px]">
      <div className="bg-white [&_#hizmetlerimiz_h2]:hidden [&>div>#hizmetlerimiz>div>p]:hidden">
        <div className="header bg-[#efefef]">
          <Container>
            <h1 className="font-raleway uppercase text-[28px] py-12 w-full font-bold">BLOG + BİZDEN HABERLER</h1>
          </Container>
        </div>
        <Container className="flex-wrap">
          <p className="text-center text-[24px] mb-12 font-lato font-light text-[#444444] relative py-12 after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:m-auto after:w-20 after:h-0.5 after:bg-[#cccccc] [&_i]:font-thin [&_i]:not-italic [&_i]:font-lato" dangerouslySetInnerHTML={{ __html: title }} />
          {blogPosts.map((post) => (
            <a href={`/blog/${slugify(post.title)}`} key={post.title} className="px-4 h-full w-full mb-20 md:w-4/12">
              <Card className="flex items-start flex-wrap shadow-none border-none">
                <img src={post.image} alt={post.title} className="w-full h-48 object-cover" />
                <CardHeader className="px-0 py-1 block font-raleway text-base text-gray-700 font-bold">
                  <CardTitle className="leading-tight flex flex-col justify-center h-12">{post.title}</CardTitle>
                </CardHeader>
                <CardContent className="p-0 font-lato text-sm text-gray-500">
                  <p className="text-sm mb-2 flex items-center gap-2 text-gray-500">
                    <Icon name="material-symbols:calendar-month" />
                    {toLocaleDateString(new Date(post.date))}</p>
                  <p>{post.excerpt}</p>
                </CardContent>
              </Card>
            </a>
          ))}
        </Container>
      </div>
      <Slogans />
      <References />
    </div>
  )
}
